import { httpBus } from "@/api/index.js";

// 更新能量链
export const updateElink = elink => {
  return httpBus.request("put", "/device/elink", { data: elink });
};

// 新增能量链（旧接口）
export const addElink = elink => {
  return httpBus.request("post", "/device/elink", { data: elink });
};

// 新增能量链（v3 接口）
export const addElinkV3 = elink => {
  return httpBus.request("post", "/device/v3/elink", { data: elink });
};

// 更新能量链（v3 接口）
export const updateElinkV3 = elink => {
  return httpBus.request("put", "/device/v3/elink", { data: elink });
};

// 获取能量链列表（v3 接口）
export const getElinkListV3 = params => {
  return httpBus.request("get", "/device/v3/elink/list", { params });
};

// 配置能量链 VPN
export const configureElinkVpn = uuid => {
  return httpBus.request("post", `/device/v3/elink/configureVpn/${uuid}`);
};

// 下载能量链 OpenVPN 配置
export const downloadElinkOvpn = uuid => {
  return httpBus.request("get", `/device/v3/elink/downloadOvpn/${uuid}`, undefined, { responseType: "blob" });
};

// 批量删除能量链
export const delElink = equipmentIds => {
  return httpBus.request("delete", `/device/elink/${equipmentIds}`);
};

// 批量删除能量链（v3 接口）
export const delElinkV3 = equipmentIds => {
  return httpBus.request("delete", `/device/v3/elink/${equipmentIds}`);
};

// 获取elink和eblock对应关系
export const getElinkStruct = stationId => {
  return httpBus.request("get", `/device/elink/eLinkList/${stationId}`);
};

// 导出设备列表
export const exportDevice = () => {
  return httpBus.request("get", "/device/elink/export");
};

// 导入能量链基本信息
export const importData = data => {
  return httpBus.request("post", "/device/elink/importData", { data });
};

// 获取导入模板
export const importTemplate = () => {
  return httpBus.request("get", "/device/elink/importTemplate");
};

// 获取能量链列表
export const getElinkList = (pageNum, pageSize, stationId, unitId) => {
  // return httpBus.request("get", "/device/elink/list", {
  //   params: { pageNum, pageSize, stationId, unitId }
  // });
};

// 查询能量链
export const queryELink = (
  pageNum,
  pageSize,
  equipmentId,
  uuid,
  stationName,
  emqxClientId
) => {
  // return httpBus.request("get", "/device/elink/list", {
  //   params: {
  //     pageNum,
  //     pageSize,
  //     equipmentId,
  //     uuid,
  //     stationName,
  //     emqxClientId
  //   }
  // });
};

// 获取能量链温度参数
export const getTempatureOption = uuid => {
  return httpBus.request("get", "/command/device/data/setting", {
    params: { uuid }
  });
};

// 获取能量链温度参数
export const setTempatureOption = data => {
  return httpBus.request("post", "/command/device/command/setting", { data });
};
